import { Button, Container, Grid, IconButton, makeStyles, useTheme } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserWordBank } from '../../actions';
import WordCard from '../DashBoard/WordCard';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';


const useStyles = makeStyles((theme) => ({
    cardSpace: {
        '&:hover': {
            transform: 'scale(1.05)',
            cursor: 'pointer'

        },
        margin: '10px 0px',

    },
    buttons: {
        margin: '40px 30px',
        transform: 'scale(1.5)'
    },
    buttonRandom: {
        margin: '30px',
        transform: 'scale(1.3)'
    }
}));
const shuffleArray = (arrayGiven) => {
    if (!arrayGiven) return;
    let array = [...arrayGiven];
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

const StudyCorner = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const classes = useStyles(theme);
    const userWordBank = useSelector(state => state.userWordBank);
    const [chosenIndex, setChosenIndex] = useState(null);
    const [wordIndex, setWordIndex] = useState(0);
    const [isFlippedFront, setIsFlipped] = useState(true);
    const [loading, setLoading] = useState(true);
    const [isDownPressed, setIsDownPressed] = useState(false);



    useEffect(() => {
        if (!userWordBank.wordBank) {
            dispatch(getUserWordBank());
        } else {
            randomizeChosenIndex(shuffleArray(Array.from({ length: userWordBank.wordBank.length }, (_, index) => index)));
        }
    }, [dispatch, userWordBank.wordBank])




    const randomizeChosenIndex = (newOrder) => {
        setChosenIndex(newOrder);
        setLoading(false);
    }

    const randomize = () => {
        setWordIndex(0);
        setIsFlipped(true);
        setLoading(true);
        randomizeChosenIndex(shuffleArray(chosenIndex));
    }


    const loadWordCard = () => {
        if (!userWordBank.wordBank?.[chosenIndex?.[wordIndex]] || loading) {
            return (
                <Grid className={classes.cardSpace} item xs={12} sm={8} md={6} lg={4}>
                    <WordCard
                        isFrontOfCard={isFlippedFront}
                        shouldBlur={false}
                        word={null}
                        handleDialogOpen={false}
                        handleClose={false}
                    />
                </Grid>
            )
        }
        return (
            <Grid onClick={() => { flipCard() }} className={classes.cardSpace} item xs={12} sm={8} md={6} lg={4}>
                <WordCard
                    isFrontOfCard={isFlippedFront}
                    shouldBlur={false}
                    word={userWordBank.wordBank?.[chosenIndex[wordIndex]]?.word}
                    handleDialogOpen={false}
                    handleClose={false}
                />

            </Grid>
        )
    }




    const incrementWordIndex = () => {
        if (wordIndex === userWordBank.wordBank.length - 1) return;
        setWordIndex(wordIndex + 1);
        setIsFlipped(true);
    }

    const decrementWordIndex = () => {
        if (wordIndex === 0) return;
        setWordIndex(wordIndex - 1);
        setIsFlipped(true)
    }

    const flipCard = () => {
        setIsFlipped(!isFlippedFront);
    }




    const handleKeyPress = (event) => {

        switch (event.key) {
            case 'ArrowRight':
                incrementWordIndex();
                break;
            case 'ArrowLeft':
                decrementWordIndex();
                break;
            case ' ':
                flipCard();
                break;
            case 'ArrowUp':
                flipCard();
                break;
            case 'ArrowDown':
                if (!isDownPressed) {
                 flipCard();
                 setIsDownPressed(true);

                }
                break;
            case 'r':
                randomize();
                break;
            default:
                break;
        }
    }

    const handleKeyUp = (event) => {
        switch (event.key) {
            case 'ArrowDown':
                flipCard();
                setIsDownPressed(false);
                break;

            default:
                break;
        }
    }
    //ToDo: you can add an instruction that arrow keys and r key are usable and swipe controls when applicable

    useEffect(() => {
        document.body.addEventListener('keydown', handleKeyPress);
        document.body.addEventListener('keyup', handleKeyUp)
        return () => {
            document.body.removeEventListener('keydown', handleKeyPress);
            document.body.removeEventListener('keyup', handleKeyUp);
        }
    });



















    return (
        <Container>
            <Grid container justify='center' alignItems="center">
                <Grid item>
                    <Button className={classes.buttonRandom} onClick={randomize} variant='outlined'>
                        Randomize
                    </Button>
                </Grid>
            </Grid>
            <Grid container justify='center' alignItems='center' >
                {loadWordCard()}
            </Grid>
            <Grid container justify='center' alignItems='center'>

                <Grid item >
                    <IconButton className={classes.buttons} onClick={decrementWordIndex} disabled={wordIndex === 0 ? true : false}>
                        <ArrowBackIosRoundedIcon />
                    </IconButton>
                </Grid>
                <Grid item >
                    <IconButton className={classes.buttons} onClick={incrementWordIndex} disabled={userWordBank.wordBank?.length - 1 === wordIndex ? true : false}>
                        <ArrowForwardIosRoundedIcon />
                    </IconButton>
                </Grid>



            </Grid>

        </Container>
    )
}

export default StudyCorner
